import { Module, Context } from 'vuex-smart-module';
import { StepManagerState } from '@/store/step-manager/state';
import { StepManagerGetters } from '@/store/step-manager/getters';
import { StepManagerMutations } from '@/store/step-manager/mutations';
import { StepManagerActions } from '@/store/step-manager/actions';

export const stepManagerModule = new Module({
	state: StepManagerState,
	getters: StepManagerGetters,
	mutations: StepManagerMutations,
	actions: StepManagerActions,
});

export type StepManagerModuleContext = Context<Module<StepManagerState, StepManagerGetters, StepManagerMutations, StepManagerActions>>;
